<template>
  <BlurredBackdrop
    :density="1"
    :is-blurred="isBlurred"
    :margin-top="marginTop"
    :min-height="minHeight"
    :min-width="minWidth"
  >
    <template v-slot:info>
      <div>
        {{ $t('alerts.upselling.upgrade.0') }}
        <!-- Use wrapper span to track the event as @click is not called on <router-link> -->
        <span @click="$tracking.event('BlurredBackdrop', 'Clicked', 'Upgrade')">
          <a
            v-if="isPlatformSmg"
            :href="helpArticleLink"
            target="_blank"
            rel="noopener noreferrer"
            style="color: #ffffff"
          >
            {{ $t('alerts.upselling.upgrade.link') }}
          </a>
          <router-link
            v-else
            class="nav-item pointer text-white font-weight-bold"
            :to="upgradeLink"
          >
            {{ $t('alerts.upselling.upgrade.link') }}
          </router-link>
        </span>
        {{ $t('alerts.upselling.upgrade.1') }}
      </div>
    </template>
    <slot />
  </BlurredBackdrop>
</template>

<script>
import brandingMixin from '@/mixins/branding.js'

import BlurredBackdrop from './BlurredBackdrop.vue'

export default {
  components: { BlurredBackdrop },
  mixins: [brandingMixin],
  props: {
    isBlurred: {
      type: Boolean,
      default: true,
    },
    marginTop: {
      type: String,
      default: '0',
    },
    minHeight: {
      type: String,
      default: '150px',
    },
    minWidth: {
      type: String,
      default: '',
    },
  },
  computed: {
    helpArticleLink() {
      return this.upgradePackageUrl
    },
    upgradeLink() {
      return {
        name: 'Settings',
        params: { section: 'contract' },
        query: { showUpgrade: '1' },
      }
    },
  },
}
</script>
